import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { referralRoute } from '.'

const Referral = lazyRouteComponent(() => import('../../../pages/profile/referral/referral'))

export const referralIndexRoute = createRoute({
  getParentRoute: () => referralRoute,
  path: '/',
  component: Referral,
})
